import * as React from "react";
import * as ReactDOM from "react-dom";
import "@fontsource/roboto";
import "./index.css";
import App from "./App";
import {LicenseInfo} from "@mui/x-data-grid-pro";

LicenseInfo.setLicenseKey("4273236824c88678a8799c0025e0ce97Tz0xMjQxODMsRT0xODAxODcxOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");

ReactDOM.render(
    <App />,
    document.getElementById("root") as HTMLElement
);

